// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16 1H8V5H16V1Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 3H3V23H13.8762C13.0139 21.897 12.5 20.5085 12.5 19C12.5 15.4101 15.4101 12.5 19 12.5C19.6978 12.5 20.3699 12.61 21 12.8135V3H18V7H6V3Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.2431 21.8284L21.8289 23.2426L19.0005 20.4142L16.172 23.2426L14.7578 21.8284L17.5862 19L14.7578 16.1715L16.172 14.7573L19.0005 17.5857L21.8289 14.7573L23.2431 16.1715L20.4147 19L23.2431 21.8284Z"}}]};

const TaskErrorFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'task-error-filled',
    ref,
    icon: element,
  },
));

TaskErrorFilledIcon.displayName = 'TaskErrorFilledIcon';

export default TaskErrorFilledIcon;
